import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss']
})
export class DateTimePickerComponent implements OnInit {

  date: string;
  time: NgbTimeStruct;
  today: string;
  @Output() dateTimeChange = new EventEmitter<{ dateTime: string }>();



  ngOnInit(): void {
    this.initProperties();
  }


  private initProperties() {

    const now = new Date();
    this.today = now.toISOString();
    var initHour = now.getHours();
    const nowHour = now.getHours();
    if (nowHour >= 6 && nowHour < 14) {
      initHour = 6;
    }
    else if (nowHour >= 14 && nowHour < 22) {
      initHour = 14;
    }
    else if (nowHour >= 22 || nowHour < 6) {
      initHour = 22;
    }
    this.time = {
      hour: initHour,
      minute: 0,
      second: 0
    };
    this.date = now.toISOString();
    this.emit();
  }

  combineDateTime(dateString: string, time: NgbTimeStruct): string {
    const tempDate = new Date(dateString);
    const year = tempDate.getFullYear();
    const month = String(tempDate.getMonth() + 1).padStart(2, '0');
    const day = String(tempDate.getDate()).padStart(2, '0');
    const hours = String(time.hour).padStart(2, '0');
    const minutes = String(time.minute).padStart(2, '0');
    const seconds = String(time.second).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  validateTime(event: any) {
    this.time = event;
    console.log(event);
    if (!this.time || this.time.hour == null || this.time.minute == null || this.time.second == null) {
      this.time = {
        hour: this.time?.hour ?? 0,
        minute: this.time?.minute ?? 0,
        second: this.time?.second ?? 0
      };
    }
    this.emit();

  }


  updateDate(event: any) {
    this.date = event;
    this.emit();
  }

  emit() {
    this.dateTimeChange.emit({ dateTime: this.combineDateTime(this.date, this.time) });
  }
}
